export default "__VITE_ASSET__DyDP5Bfu__"